import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const seafile = defineConnector({
  identifier: "seafile",
  name: "Seafile",
  tagLine: "Self-hosted file sync and share platform",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `${app.config.instanceUrl}/api2/auth-token/`,
        method: "POST",
        formBody: {
          username: app.config.username,
          password: app.secret.password,
        },
      },
      extract: { from: "jsonPath", paths: ["token"] },
      apply: { kind: "header", scheme: "Token" },
    }),
  steps: [
    {
      title: "Enter your Seafile details",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://seafile.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Seafile server.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          placeholder: "you@example.com",
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api2/auth/ping/`,
  },
});
